import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiSublimetext,
  SiPhpstorm,
  SiLinux,
  SiGithub,
  SiJira,
  SiBitbucket,
  SiCypress,
} from "react-icons/si";

const toolItems = [
  { icon: <SiLinux />,            label: "Linux"      },
  { icon: <SiVisualstudiocode />, label: "VS Code"    },
  { icon: <SiPhpstorm />,        label: "PhpStorm"   },
  { icon: <SiSublimetext />,     label: "Sublime"    },
  { icon: <SiPostman />,         label: "Postman"    },
  { icon: <SiSlack />,           label: "Slack"      },
  { icon: <SiJira />,            label: "Jira"       },
  { icon: <SiGithub />,          label: "GitHub"     },
  { icon: <SiBitbucket />,       label: "Bitbucket"  },
  { icon: <SiCypress />,         label: "Cypress"    },
];

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {toolItems.map(({ icon, label }) => (
        <Col key={label} xs={4} md={2} className="tech-icon-col">
          <div className="tech-icons" title={label}>
            {icon}
            <p className="tech-icon-label">{label}</p>
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
